export class State {
  stateId?: number;
  stateName: string;
  stateAbbr: string;
}
